import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getStillageData } from 'services/glass-management/glassManagement';

export const fetchStillage = createAsyncThunk('glass/stillage/fetch', async (filters) => {
    const res = await getStillageData(filters.start, filters.end);
    return { data: res };
});

export const stillageSlice = createSlice({
    name: 'glassStillage',
    initialState: {
        data: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchStillage.pending, state => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchStillage.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action?.payload?.data;
            })
            .addCase(fetchStillage.rejected, (state, action) => {
                state.loading = false;
                state.error = action?.error?.message ?? 'Failed to load Stillage';
                state.data = null;
            });
    }
});

export default stillageSlice.reducer;
